import { ComponentType } from 'react';
import { SpamClassification } from 'modules/templateEditor/common/constants';
import styled from 'styled-components';
import { ErrorFill16, InfoFill16, SuccessFill16, WarningFill16 } from 'ui/icons';
import { colors, spacing } from 'ui/theme';

const SpamReportItem = styled.div`
  display: flex;  
  align-items: center;
  color: ${({ color = colors.textPrimary }) => color};
  gap: ${spacing.half};
`;

interface ClassificationConfig {
  text: string;
  color: string;
  Icon: ComponentType<{ color: string }>;
}

const spamReportClassificationConfig: Record<SpamClassification, ClassificationConfig> = {
  [SpamClassification.NotSpam]: { text: 'Pass', color: colors.textSuccess, Icon: SuccessFill16 },
  [SpamClassification.Neutral]: { text: 'Neutral', color: colors.grey60, Icon: InfoFill16 },
  [SpamClassification.Spam]: { text: 'Fail', color: colors.red100, Icon: ErrorFill16 },
  [SpamClassification.StillProcessing]: {
    text: 'Still Processing',
    color: colors.info100,
    Icon: WarningFill16,
  },
};

export const SpamReportClassificationLabel = ({
  classification,
}: { classification: SpamClassification }) => {
  const { text, color, Icon } = spamReportClassificationConfig[classification];
  return (
    <SpamReportItem color={color}>
      <Icon color={color} /> {text}
    </SpamReportItem>
  );
};
